// extracted by mini-css-extract-plugin
export default {"Heading":"wm96her6"};